import React from 'react';
import { AppProvider } from './AppProvider';
import ProtectedRoute from './ProtectedRoutes';

const App = () => (
  <AppProvider>
    <div className="App">
      <ProtectedRoute />
    </div>
  </AppProvider>
);

export default App;
